import { render } from "./crear_baremo.vue?vue&type=template&id=80a4f2a2"
import script from "./crear_baremo.vue?vue&type=script&lang=js"
export * from "./crear_baremo.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__